// .guide_links内のページ内リンクをスムーズスクロールするスクリプト

document.addEventListener("DOMContentLoaded", function () {
    const guideLinks = document.querySelector(".guide_links");

    if (guideLinks) {
        // .guide_links 内のすべてのリンクを取得
        const links = guideLinks.querySelectorAll("a[href^='#']");

        links.forEach(link => {
            link.addEventListener("click", function (event) {
                event.preventDefault(); // デフォルトの動作を防ぐ

                const targetId = this.getAttribute("href").slice(1); // #を除いたIDを取得
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // スムーズスクロール
                    window.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: "smooth"
                    });
                }
            });
        });
    }
});


// document.addEventListener('DOMContentLoaded', function () {
//     // 全てのチェックボックスとボタンを取得
//     const checkboxes = document.querySelectorAll('#terms_checkbox'); // 利用規約のチェックボックス (複数)
//     const checkoutButtons = document.querySelectorAll('.drawer_checkout_btn[name="checkout"]'); // チェックアウトボタン (複数)

//     // 初期状態で全てのボタンを無効化
//     checkoutButtons.forEach(function (button) {
//         button.disabled = true;
//     });

//     // 各チェックボックスにイベントリスナーを追加
//     checkboxes.forEach(function (checkbox) {
//         checkbox.addEventListener('change', function () {
//             // 対応するボタンを有効/無効にする
//             checkoutButtons.forEach(function (button) {
//                 button.disabled = !checkbox.checked;
//             });
//         });
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("a[href]");
  const currentDomain = location.origin;

  links.forEach(link => {
    const href = link.getAttribute("href");
    if (link.target === "_blank") return;
    if (
      href.startsWith("#") ||
      href.startsWith("/") ||
      href.startsWith(".") ||
      href.startsWith(currentDomain)
    ) {
      return;
    }
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noreferrer noopener");
  });
});